export const CALCULATE_RATES_SUCCESS = 'CALCULATE_RATES_SUCCESS',
  CALCULATE_RATES_FAIL = 'CALCULATE_RATES_FAIL',
  CHECK_SHIPPING_RATE_SUCCESS = 'CHECK_SHIPPING_RATE_SUCCESS',
  CHECK_SHIPPING_RATE_FAIL = 'CHECK_SHIPPING_RATE_FAIL',
  FUEL_SURCHARGE_SUCCESS = 'FUEL_SURCHARGE_SUCCESS',
  FUEL_SURCHARGE_FAIL = 'FUEL_SURCHARGE_FAIL'
